export const ourClients = [
  {
    img: require("../../assets/images/clients/c1.webp"),
  },
  {
    img: require("../../assets/images/clients/c2.webp"),
  },
  {
    img: require("../../assets/images/clients/c3.webp"),
  },
  {
    img: require("../../assets/images/clients/c4.webp"),
  },
  {
    img: require("../../assets/images/clients/c5.webp"),
  },
  {
    img: require("../../assets/images/clients/c6.webp"),
  },
  {
    img: require("../../assets/images/clients/c7.webp"),
  },
  {
    img: require("../../assets/images/clients/c8.webp"),
  },
  {
    img: require("../../assets/images/clients/c9.webp"),
  },
  {
    img: require("../../assets/images/clients/c10.webp"),
  },
  {
    img: require("../../assets/images/clients/c11.webp"),
  },
  {
    img: require("../../assets/images/clients/c12.webp"),
  },
  {
    img: require("../../assets/images/clients/c13.webp"),
  },
  {
    img: require("../../assets/images/clients/c14.webp"),
  },
  {
    img: require("../../assets/images/clients/c15.webp"),
  },
  {
    img: require("../../assets/images/clients/c16.webp"),
  },
];
export const technologyPartner = [
  {
    img: require("../../assets/images/technology/t1.webp"),
  },
  {
    img: require("../../assets/images/technology/t2.webp"),
  },
  {
    img: require("../../assets/images/technology/t3.webp"),
  },
  {
    img: require("../../assets/images/technology/t4.webp"),
  },
  {
    img: require("../../assets/images/technology/t5.webp"),
  },
  {
    img: require("../../assets/images/technology/t6.webp"),
  },
  {
    img: require("../../assets/images/technology/t7.webp"),
  },
];

export const caseStudy = [
  {
    title: "Incredible Results and a Team That Truly Cares",
    para: "From day one, their team understood our objectives and delivered powerful digital marketing services in India that produced real, measurable results. Our website traffic doubled, Google Ads performance improved significantly, and our social media engagement saw remarkable growth. If you’re looking for a trusted growth partner, SMS ZOO ZOO is the right choice.",
    name: "Prabu G",
    company: "Compass Group India"

  },
  {
    title: "",
    para: "We’ve worked with several marketing agencies in the past, but none have come close to the level of service, creativity, and performance we’ve experienced with. Their team to SMS ZOO ZOO ok the time to understand our brand, our audience, and our goals — and it shows in the results. We’re excited to continue growing with SMS ZOO ZOO and would confidently recommend them to any business ready to elevate their digital presence",
    name: "Simbhu",
  },
  {
    title: "",
    para: "Their professionalism, strategy, and execution make them a standout provider of digital marketing services in India.",
    name: "Rasiga",
  }
];

export const initialStates = [
  { top: -55, left: 132, width: 50, height: 50, marginLeft: 0, opacity: 1, top2: 100, left2: 30 },
  { top: -73, left: 154, width: 20, height: 20, marginLeft: 0, opacity: 1 },
  { top: -46, left: 197, width: 40, height: 40, marginLeft: -10, opacity: 1 },
  { top: -80, left: 188, width: 25, height: 25, marginLeft: 5, opacity: 1 },
];

export const State_two = [
  { top: 0, left: 0, width: 50, height: 50, marginLeft: 0, opacity: 1 },
  { top: 0, left: 0, width: 50, height: 50, marginLeft: 0, opacity: 1 },
  { top: 0, left: 0, width: 50, height: 50, marginLeft: 0, opacity: 1 },
  { top: 0, left: 0, width: 50, height: 50, marginLeft: 0, opacity: 1 },
];

export const targetStates = [
  { top: 1227, left: 207, width: 53, height: 53, marginLeft: 0, opacity: 1 },
  { top: 1280, left: 240, width: 53, height: 53, marginLeft: 0, opacity: 1 },
  { top: 1330, left: 200, width: 53, height: 53, marginLeft: 0, opacity: 1 },
  { top: 1400, left: 230, width: 53, height: 53, marginLeft: 0, opacity: 1 },
];

export const easeInOutQuad = (t) =>
  t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

export const whychoose = [
  {
    id: 1,
    title: "Expertise In <br/> Digital Marketing",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
    content:
      "We specialize in innovative, results-driven digital marketing services in India, including SMS marketing, social media advertising, LinkedIn ads, and WhatsApp marketing.",
  },
  {
    id: 2,
    title: "Affordable & Scalable <br/> Solutions",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
    content:
      "Whether you're a startup or a large enterprise, our digital marketing solutions are tailored to fit your budget and scale as your business grows.",
  },
  {
    id: 3,
    title: "Data-Driven <br/> Results",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
    content:
      "We use advanced analytics to track and optimize campaigns, ensuring you get the best ROI for your marketing spend.",
  },
  {
    id: 4,
    title: "Customer-Centric <br/> Approach",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
    content:
      "Your success is our priority! We work closely with you to develop custom marketing strategies that align with your business goals.",
  },
];

export const accordionItemscontent = [
  {
    id: 1,
    question: "What is Business WhatsApp?",
    answer:
      "Business WhatsApp is a messaging platform that allows businesses to communicate with customers and provide customer support.",
  },
  {
    id: 2,
    question: "How does Business WhatsApp work?",
    answer:
      "Businesses can use Business WhatsApp to send and receive messages, images, videos, and other files to and from customers.",
  },
  {
    id: 3,
    question: "What are the benefits of using  Business WhatsApp?",
    answer:
      "The benefits include increased customer engagement, improved customer support, and enhanced business efficiency.",
  },
  {
    id: 4,
    question:
      "What is the difference between WhatsApp Business and WhatsApp?",
    answer:
      "WhatsApp Business is a separate app designed specifically for businesses, while WhatsApp is the standard messaging app for personal use.",
  },
  {
    id: 5,
    question: "Can I use my personal WhatsApp account for business purposes?",
    answer:
      "No, it's recommended to use a separate WhatsApp Business account for business purposes to maintain a professional presence and comply with WhatsApp's terms of service.",
  },
  {
    id: 6,
    question:
      "How do I send messages to customers on  Business WhatsApp?",
    answer:
      "You can send messages to customers on Business WhatsApp by typing in the chat window and sending the message.",
  },
  {
    id: 7,
    question: "Can I automate responses on Business WhatsApp?",
    answer:
      "Yes, you can automate responses on Business WhatsApp using WhatsApp's automated messaging features.",
  },
  {
    id: 8,
    question: "How do I handle customer inquiries on  Business WhatsApp?",
    answer:
      "You can handle customer inquiries on Business WhatsApp by responding to messages promptly and providing helpful and accurate information.",
  },
  {
    id: 9,
    question: "Are transactions on Business WhatsApp secure?",
    answer:
      "Yes, transactions on Business WhatsApp are secure and encrypted to protect customer information.",
  },
  {
    id: 10,
    question:
      "Can I integrate Business WhatsApp with other business tools?",
    answer:
      "Yes, you can integrate  Business WhatsApp with other business tools, such as CRM systems and customer support software.",
  },
  {
    id: 11,
    question: "Is Business WhatsApp secure?",
    answer:
      "Yes, Business WhatsApp is secure and encrypted to protect customer information.",
  },
  {
    id: 12,
    question: "What are the benefits of using Business WhatsApp API?",
    answer:
      "The benefits of using Business WhatsApp API include increased customer engagement, improved customer support, and enhanced business efficiency.",
  },
  {
    id: 13,
    question: "How much does Business WhatsApp API cost?",
    answer:
      "The cost of Business WhatsApp API varies depending on the number of messages sent and received.",
  },
  {
    id: 14,
    question: "WhatsApp Marketing legal?",
    answer:
      "Yes, WhatsApp Marketing is legal when using an official WhatsApp API-based platform like. Top businesses like Skullcandy, Flipkart, and Byjus use WhatsApp Marketing.",
  },
  {
    id: 15,
    question: "How can I grow my audience on WhatsApp?",
    answer: [
      "Sharing WhatsApp Links on social media and product packaging \nAdding a WhatsApp Button to your website \nImplementing a WhatsApp pop-up on your website \nAdding a WhatsApp QR Code on packaging and in-store",
    ],
  },
  {
    id: 16,
    question: "How to do bulk WhatsApp Marketing?",
    answer: [
      "Broadcast messages to unlimited users   \nProvide live chat on multiple devices",
    ],
  },
];

export const servicescontent = [
  {
    id: 1,
    title: "Profile & Page \nVerification",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
  },
  {
    id: 2,
    title: "Instant Account \nActivation",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
  },
  {
    id: 3,
    title: "Brand & Public \nFigure Verification",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
  },
  {
    id: 4,
    title: "Document & \nEligibility Assistance",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
  },
];
export const servicessender = [
  {
    id: 1,
    title: "DLT Registration \nAssistance",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
  },
  {
    id: 2,
    title: "Sender ID \nApproval",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
  },
  {
    id: 3,
    title: "Template \nRegistration",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
  },
  {
    id: 4,
    title: "Bulk SMS \nPlatform Integration",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
  },
];
export const accordionItemsvirtual = [
  {
    id: 1,
    question: "How do I send messages via the 10-digit number?",
    answer:
      "To send messages, simply use the designated 10-digit number provided by the service. Include your message and attach any media files within the allowed limits.",
  },
  {
    id: 2,
    question: "What types of media can I send?",
    answer:
      "You can send up to 3 images, videos, and PDF files in each message. Ensure the files meet the specified size and format requirements.",
  },
  {
    id: 3,
    question: "Are there size limits for the media files?",
    answer:
      "Yes, each media file may have specific size limits depending.Please check the guidelines for detailed information on 5 MB maximum file sizes.",
  },
  {
    id: 4,
    question: "Can I send messages to multiple recipients at once?",
    answer: "Send messages to over 100,000 recipients in a single day,",
  },
  {
    id: 5,
    question: "Is there a charge for sending media files?",
    answer:
      "Not Separate cost for sending media. Review your plan details or contact customer support for clarification on any costs associated with media messaging.",
  },
  {
    id: 6,
    question: "How can I track the performance of my messages?",
    answer:
      "Many messaging services offer analytics and reporting features that allow you to track open rates, engagement levels, and other metrics related to your messages.",
  },
  {
    id: 7,
    question: "What should I do if there are delivery issues?",
    answer:
      "If you experience delivery issues, check the recipient’s number for accuracy, ensure your media meets the size and format requirements, and confirm that your account is in good standing. If problems persist, contact customer support for assistance.",
  },
  {
    id: 8,
    question: "Can I customize the sender name or number?",
    answer:
      "NO, services use a default 10-digit number for sending messages. ",
  },
];
export const servicesvirtual = [
  {
    id: 1,
    title: "Instant Account \nActivation",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
  },
  {
    id: 2,
    title: "Lead \nGeneration",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
  },
  {
    id: 3,
    title: "Customer \nEngagement",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
  },
  {
    id: 4,
    title: "Track Live \nReport",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
  },
];

export const serviceswapp = [
  {
    id: 1,
    title: "Google Registration \nAssistance",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
  },
  {
    id: 2,
    title: "Sender ID \nApproval",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
  },
  {
    id: 3,
    title: "Template \nRegistration",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
  },
  {
    id: 4,
    title: "Bulk SMS \nPlatform Integration",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
  },
];
export const accordionItemsfb = [
  {
    id: 1,
    question: "What are social media marketing services?",
    answer:
      "Social media marketing services involve promoting brands, products, or services on platforms like Facebook and Instagram using organic content and paid advertising.",
  },
  {
    id: 2,
    question: "Why use Facebook & Instagram marketing?",
    answer:
      "Facebook & Instagram marketing allows businesses to reach a large and targeted audience, increase brand awareness, drive website traffic, and generate leads and sales.",
  },
  {
    id: 3,
    question: "How does Facebook & Instagram marketing work?",
    answer:
      "Facebook & Instagram marketing works by creating ads that are displayed to Facebook users based on their demographics, interests, behaviors, and other targeting options.",
  },
  {
    id: 4,
    question: "What types of Facebook & Instagram ads are available?",
    answer:
      " Facebook offers a variety of ad formats, including image ads, video ads, carousel ads, collection ads, and story ads.",
  },
  {
    id: 5,
    question: "What targeting options are available on Facebook?",
    answer:
      "Facebook offers a range of targeting options, including demographics, interests, such as age, location, behaviors, connections, and custom audiences.",
  },
  {
    id: 6,
    question: "Can I target specific Facebook groups?",
    answer:
      "Yes, you can target specific Facebook groups by using the Groups targeting option.",
  },
  {
    id: 7,
    question: "What metrics are available for Facebook ads? ",
    answer:
      "Facebook provides a range of metrics for ads, including reach, impressions, clicks, conversions, and return on ad spend (ROAS).",
  },
  {
    id: 8,
    question: "What is the difference between reach and impressions?",
    answer:
      " Reach refers to the number of unique people who see your ad, while impressions refer to the total number of times your ad is displayed.",
  },
  {
    id: 9,
    question: "What happens if my Facebook ad is rejected?",
    answer:
      "If your Facebook ad is rejected, you will receive a notification explaining why the ad was rejected and what changes you need to make to comply with Facebook's ad policies.",
  },
];

export const servicesfb = [
  {
    id: 1,
    title: "Targeting \nAudience",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
  },
  {
    id: 2,
    title: "Budget \nand Bidding",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
  },
  {
    id: 3,
    title: "Monitor \nand Optimize",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
  },
  {
    id: 4,
    title: "Report \n& Analysis",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
  },
];

export const servicesln = [
  {
    id: 1,
    title: "Targeting Options",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
  },
  {
    id: 2,
    title: "Budget and Bidding",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
  },
  {
    id: 3,
    title: "Monitor and Optimize",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
  },
  {
    id: 4,
    title: "Report & Analysis",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
  },
];

export const servicesgoogle = [
  {
    id: 1,
    title: "Keyword Research",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
  },
  {
    id: 2,
    title: "Ads Management",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
  },
  {
    id: 3,
    title: "Measurable Results",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
  },
  {
    id: 4,
    title: "Increased Conversions",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
  },
];
export const servicesppc = [
  {
    id: 1,
    title: "Strategy & \nKeyword Research",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
  },
  {
    id: 2,
    title: "Google Ads & \nBing Ads Management",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
  },
  {
    id: 3,
    title: "Landing Page \nOptimization",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
  },
  {
    id: 4,
    title: "Tracking & \nReporting",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
  },
];
export const servicesseo = [
  {
    id: 1,
    title: "Keyword \nResearch",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
  },
  {
    id: 2,
    title: "On-Page \nSEO",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
  },
  {
    id: 3,
    title: "Off-Page \nSEO",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
  },
  {
    id: 4,
    title: "Local \nSEO",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
  },
];


export const whychoose2 = [
  {
    id: 1,
    title: "Expertise In Digital Marketing",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
    content:
      "We specialize in innovative, results-driven digital marketing services in India, including SMS marketing, social media advertising, LinkedIn ads, and WhatsApp marketing.",
  },
  {
    id: 2,
    title: "Affordable & Scalable Solutions",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
    content:
      "Whether you're a startup or a large enterprise, our digital marketing solutions are tailored to fit your budget and scale as your business grows.",
  },
  {
    id: 3,
    title: "Data-Driven Results",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
    content:
      "We use advanced analytics to track and optimize campaigns, ensuring you get the best ROI for your marketing spend.",
  },
  {
    id: 4,
    title: "Customer-Centric Approach",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
    content:
      "Your success is our priority! We work closely with you to develop custom marketing strategies that align with your business goals.",
  },
];

export const gridcontent = [
  {
    id: 1,
    heading: "Understanding the Social Media Landscape",
    para1: "Choosing the right platform is critical for success. Our social media marketing services analyze your industry, target audience, and business goals to focus on platforms where your customers are most active—mainly Facebook and Instagram.",
    para2: "Our experts stay updated with platform algorithms, ad formats, and trends to keep your brand ahead of competitors. As a leading social media marketing agency in India, SMS ZOO ZOO helps businesses attract attention, build awareness, and drive sustainable growth.",
    img: require("../../../src/assets/images/gridimg/SOCIAL MEDIA 1.webp")
  },
  {
    id: 2,
    heading: "Crafting the Right Audience Persona",
    para1: "Defining the right audience allows us to create highly targeted and relevant campaigns.",
    para2: "By analyzing demographics like age, gender, location, and interests, our social media marketing services ensure your content directly addresses audience pain points—resulting in higher engagement and better ROI.",
    img: require("../../../src/assets/images/gridimg/SOCIAL MEDIA 2.webp")
  },
  {
    id: 3,
    heading: " Interesting Engagement Strategies",
    para1: "Social media engagement can significantly impact your business by turning your followers into loyal customers. It’s important to invest time in building relationships with your audience, as you can expect to see an increase in sales, customer loyalty, and positive reviews. Quickly responding to their queries and offering great customer service on social media platforms, and going the extra mile to assist them, can help build a higher level of trust and retention.",
    para2: "As a leading social media marketing company in India, we are experienced in creating engaging social media presence for various types of businesses like yours, to increase brand awareness and drive conversions. This not only engages your audience but also serves as social proof for your brand.",
    img: require("../../../src/assets/images/gridimg/SOCIAL MEDIA 3.webp")
  },
  {
    id: 4,
    heading: " Maximizing Reach with Paid Social Ads",
    para1: "Paid ads play a key role in scaling visibility. Our social media marketing services include image ads, video ads, carousel ads, and story ads—customized based on your campaign goals.",
    para2: "With smart targeting and budget optimization, we help you reach more people without overspending.",
    img: require("../../../src/assets/images/gridimg/SOCIAL MEDIA 4.webp")
  },
  {
    id: 5,
    heading: "Performance Analytics and Insights",
    para1: "The main goal of social media analytics is to gather and analyse the data from organic and paid marketing campaigns to make informed business decisions in future. We start by determining the key metrics such as reach, engagement, clicks, conversions, and ROI to measure the success of your campaigns.",
    para2: "Our team, among the best in India social media companies, makes the best use of platform-specific analytics tools such as Facebook Insights, LinkedIn Analytics and much more to track performance on each social media platform. Integrated social media listening and scheduling tools also come with their own analytics dashboards. To track website traffic, user behaviour, and conversions driven by your social media campaigns.",
    img: require("../../../src/assets/images/gridimg/SOCIAL MEDIA 5.webp")
  },

]

export const gridgoogle = [
  {
    id: 1,
    heading: "Laying a Strong Foundation for Ads",
    para1: "Developing a successful Google Ads marketing campaign requires thorough market research and analysis of your target audience. It is essential to have a deep understanding of consumer behaviour and market trends to build effective marketing strategies. We assist you in defining your marketing objectives, such as increasing website traffic, generating leads, or boosting sales. This will allow you to measure the success and ROI of your Google Ads strategy.",
    para2: "To identify the most suitable keywords for your business, our team uses the Keyword Planner tool to research relevant keywords and understand match types (broad match, phrase match, exact match) and their impact on your ads. Our experts create high-quality ads that align with your keywords and landing pages and apply their knowledge of ad relevance, expected click-through rate (CTR), and landing page experience. By continuously optimizing ad campaigns, targeting relevant keywords, and adhering to Google’s guidelines, we improve ad performance, increase click-through rates, and ultimately drive more conversions.",
    img: require("../../../src/assets/images/gridimg/google ad 1.webp")
  },
  {
    id: 2,
    heading: "Complete Competitor Ads Analysis",
    para1: "Competitor analysis is a crucial step in Google Ads marketing and involves several stages to gain an in-depth understanding of your competitors’ strategies, strengths, and weaknesses. Firstly, we identify your competitors by searching for businesses that offer similar products or services to yours and target the same audience. We use helpful tools such as Google Keyword Planner or SEMrush to find out the keywords your competitors are targeting in their ads.",
    para2: "Our experts conduct a comprehensive analysis of your competitors’ ad copies to understand their messaging, offers, and unique selling points (USPs). We use tools like Google Ads’ Auction Insights report or third-party tools to compare your performance metrics (e.g., CTR, conversion rate, ROAS) against your competitors. With a comprehensive competitor analysis, we help you improve your own Google Ads campaigns and stay ahead of the competition.",
    img: require("../../../src/assets/images/gridimg/google ad 2.webp")
  },
  {
    id: 3,
    heading: " Smart Budgeting for Maximum ROI",
    para1: "Google Ads can significantly improve the visibility and accessibility of your business without breaking the bank. However, it’s crucial to make budget decisions based on your company’s objectives. Our search engine marketing team in Chennai can help you create campaigns that are tailored to meet your objectives and allocate funds effectively. To achieve this, we clearly define your campaign goals and KPIs from the very beginning.",
    para2: "We allocate more budget to keywords that have a high ROI and drive conversions, using automated bidding strategies to optimize bids for these keywords. We also ensure that your campaign budget is used wisely by regularly monitoring its performance. We identify high-performing and low-performing areas and reallocate the budget accordingly. We also maximize your budget by focusing on high-converting times and using ad scheduling to show your ads when your target audience is most likely to convert.With a continuous iterative process, we help optimize your budget over time for maximum ROI. We review your campaign performance and adjust it based on data and insights. At SMS ZOO ZOO, we understand your business goals and help you achieve them with the help of Google Ads at the optimal budget.",
    img: require("../../../src/assets/images/gridimg/google ad 3.webp")
  },
  {
    id: 4,
    heading: "  Reaching the Right Audience",
    para1: "Connecting with the right audience is crucial for the success of your Google Ads campaign. It helps drive high conversion rates and qualified leads. To refine your keyword targeting and reach users who are actively searching for products or services similar to yours, we recommend implementing keyword match types such as broad match, phrase match, and exact match.",
    para2: "Our team of experts utilizes Google Ads’ audience targeting options to reach specific groups of people. This includes demographic targeting (age, gender, income), interest targeting, and remarketing to people who have visited your website before. We suggest filtering location-based targeting to further reach people in your target market and exclude irrelevant locations. We also recommend refining your ads based on language to target users who speak a specific language and are more likely to engage with your ads.Google also allows you to target your ads to specific devices (desktop, mobile, tablet) based on your audience’s device preferences. Our team can help you create custom audiences based on your customer data, such as email lists or website visitors. This will greatly help in reaching people who are already familiar with your brand. At SMS ZOO ZOO, we continuously test and optimize your targeting strategies based on performance data to produce the best possible results for every ad campaign we work on.",
    img: require("../../../src/assets/images/gridimg/google ad 4.webp")
  },
  {
    id: 5,
    heading: "Data-Driven Decision Making",
    para1: "Optimizing Google Ads campaigns through in-depth analysis and data analysis can help improve the performance of your ads, reduce wasted ad spend, and achieve a higher ROI. With real-time campaign data, you can monitor metrics such as click-through rate (CTR), conversion rate, and return on ad spend (ROAS) in order to improve campaign performance.",
    para2: "By analysing demographic data, interests, and behaviour, we tailor your ads and targeting to reach the right audience with the right message. Our team allocates your budget more effectively by identifying and prioritizing high-performing ads and keywords, while pausing or reducing the budget for underperforming ads.Our data-driven approach ensures that every advertising dollar is spent efficiently, resulting in more effective campaigns and better outcomes for businesses like yours. With our team working closely with your business, you get constant guidance to lead your brand to success every step of the way.",
    img: require("../../../src/assets/images/gridimg/google ad 5.webp")
  },

]

export const gridsco = [
  {
    id: 1,
    heading: "Technical SEO Audit",
    para1: "Conducting a technical SEO audit is an important component of a website’s assessment and management. It helps appraise a website’s technical aspects, identify and fix the issues that may affect its performance in Google search results. Our team of experts conduct regular audits to keep an eye on website performance. As one of the top SEO Company in India, we create more targeted and effective marketing campaigns that help your business attract and retain more customers.",
    para2: "Our commitment to keeping our SEO team abreast of the latest trends and strategies has not only helped us overcome the frequent algorithmic changes that affect your business’s significant results.",
    img: require("../../../src/assets/images/gridimg/SEO 1.webp")
  },
  {
    id: 2,
    heading: "Comprehensive Keyword Research",
    para1: "Keyword research is perhaps the most foundational aspect of search engine optimization. The prime purpose of keyword research is for gaining deep insights into the potential client, the type of content they consume and the content that will influence them to make a purchase decision. The experts at our SEO company in Chennai are the best in strategically incorporating your target keywords into your website and also increase Google rankings.",

    img: require("../../../src/assets/images/gridimg/SEO 2.webp")
  },
  {
    id: 3,
    heading: " Tag Optimization",
    para1: "The tag optimization process includes changing various HTML tags in the code of the website for the strategic objectives. Our SEO services in Chennai consist of elements like title tags, meta descriptions, header tags (H1, H2, etc.), and image alt tags. As the best SEO company in India, we at SMS ZOO ZOO customize recommendations to the meta tags of your website to serve the dual purpose like capturing the attention of users in search engine results and also to provide search engines with information about the content of the page. ",

    img: require("../../../src/assets/images/gridimg/SEO 3.webp")
  },
  {
    id: 4,
    heading: "Quality Link Profile",
    para1: "Every website should have a quality link profile with various types of backlinks. The overall quality of the link profile shows that the website is a valuable resource within its specific domain and industry. we conduct regular audits and reviews of your website’s link profile with the help of backlink analyse tools like Uber suggest, SEMrush, Ahrefs and much more.",

    img: require("../../../src/assets/images/gridimg/SEO 4.webp")
  },
  {
    id: 5,
    heading: " Google Business Page Optimization",
    para1: "To increase the visibility and credibility of businesses, especially local businesses, it’s important to set up a distinct Google Business Page. Our SEO services in Chennai recommend you to add relevant keywords into the business name and description to improve the SEO of your website. By using good customer reviews, you can create trust and credibility, which attracts more customers to your business. We at SMS ZOO ZOO, implement the latest SEO strategies as an expert in local SEO services in India.",

    img: require("../../../src/assets/images/gridimg/SEO 5.webp")
  },
  {
    id: 6,
    heading: "Reports",
    para1: "Reporting plays a major role in detecting the current performance and areas of improvement in the overall SEO strategy. It gives a clear measurement of the effectiveness of our SEO efforts by monitoring key performance indicators like organic traffic, keyword rankings, backlinks, and conversion rates. Being a top SEO firm in India, our professionals regularly identify and inform you about the improvement areas and regularly update stakeholders such as yourself with the ROI of SEO efforts.",

    img: require("../../../src/assets/images/gridimg/SEO 6.webp")
  },

]

export const gridln = [
  {
    id: 1,
    heading: "Sponsored Content",
    para1: "A LinkedIn sponsored ad pops up on the feed screen, and you can publish them from mobile and desktop devices. With sponsored content like that, you can reach and build lasting relationships. For that, our LinkedIn advertising professionals develop attractive content and add value. As one of the best top LinkedIn Company in India, we create more targeted and effective marketing campaigns that help your business attract and retain more customers.",
    img: require("../../../src/assets/images/gridimg/LinkedIn 1.webp")
  },
  {
    id: 2,
    heading: "Sponsored InMail",
    para1: "In Mail is LinkedIn's internal communication system allowing the exchange of internal messages and e-mails to other people on LinkedIn. If you would like that your message should directly reach the inbox of your target audience, Sponsored InMail’s are best. Like E-mail marketing, it can allow direct communication between a brand and its audience.  Unlike the traditional method, the message arrives in the inbox for the prospect to review. Considering the ROI, Sponsored InMail’s perform better than other Ad formats. The best LinkedIn advertising service provider company in India for this.",

    img: require("../../../src/assets/images/gridimg/LinkedIn 2.webp")
  },
  {
    id: 3,
    heading: "Text Ads",
    para1: "These ads serve on a pay-per-click or pay-per-impression model. Despite the name, text ads can also contain images. It also allows us to choose the audience, pay if people click on them, and generate website traffic. This Ad format offers you to run an Ad with engaging headlines with crisp descriptions. It is also a low-cost advertisement and get great results. As a LinkedIn Marketing company, we at SMS ZOO ZOO strive to maximise your ROI with this strategy.",

    img: require("../../../src/assets/images/gridimg/LinkedIn 3.webp")
  },
  {
    id: 4,
    heading: "Dynamic Ads",
    para1: "A dynamic ad like the ones used in Google Ads campaigns has a series of parameters adapted to the audience. It makes the ad appear more personalised to every visitor. The ad integrates fields replaced with the data of each visitor. It can include the profile photo, company name, job title, person's name, position, etc. You can count us as your LinkedIn ads service provider for this. These Ads appear at the right column of your desktop window on LinkedIn.",

    img: require("../../../src/assets/images/gridimg/LinkedIn 4.webp")
  },
  {
    id: 5,
    heading: "Image Ad",
    para1: "People scroll through their feeds at a very fast rate and getting attention is very difficult with just text Ads. Although it may be the most straightforward way to share an advertising message with an audience, don’t underestimate the power of an image. There are people who love crisp information presented to them in a hyper-creative & innovative way. If you have well thought & a great image illustration of your offerings why publish it to a wider audience? A campaign with strong visuals can increase brand awareness and entice your audience to follow through on your call to action.",

    img: require("../../../src/assets/images/gridimg/LinkedIn 5.webp")
  },
  {
    id: 6,
    heading: " Carousel Image Ad",
    para1: "Do you have multiple offerings or products & you would like to present together in a single Ad, Carousel Image Ads are best. If someone is not interested in one offering, they might be interested in another one & can eventually become your customer. This format increases user interaction, thanks to its swipe able content, which drives higher engagement rates. You also have the option to complement your Ad with a relevant image.",

    img: require("../../../src/assets/images/gridimg/LinkedIn 6.webp")
  },
  {
    id: 7,
    heading: "Video Ad",
    para1: "Would you like to tell a story relevant to your offering? Video Ads are quite engaging. YouTube and TikTok may be dominating the world of social video, but that doesn’t mean you can’t have some fun with it over on LinkedIn, too LinkedIn even says video is their fastest growing content format. For a LinkedIn video Ad format, You can include a video ranging from 3 seconds to 30 minutes.",

    img: require("../../../src/assets/images/gridimg/LinkedIn 7.webp")
  },
  {
    id: 8,
    heading: " Conversation Ads",
    para1: "Sponsored InMail’s offer a single call to action for users. To enhance the user experience, Conversation Ads offer different “call to action” options (up to 5) to increase click-through rate & response rates. The purpose of this Ad is to drive conversation & give the user the power to choose more options to initiate a conversation with the advertiser. There’s no better way to get up close and personal with your target audience than to slide into their DMs.",

    img: require("../../../src/assets/images/gridimg/LinkedIn 8.webp")
  },
  {
    id: 9,
    heading: "Followers Ad",
    para1: "Followers on any platform depict the authority & scale of your business. While the organic following is gradual, LinkedIn Follower Ad helps you to gain targeted followers in a short amount of time. Depending on your budget, you can gain followers on LinkedIn & be authoritative. Cost-wise, followers Ads are best suited for mid to large-scale businesses.",

    img: require("../../../src/assets/images/gridimg/LinkedIn 9.webp")
  },

]

export const gridppc = [
  {
    id: 1,
    heading: "Search Ads",
    para1: "Target new customers who are looking for your products and services. Use search ads for short sale cycles and pilot campaigns and acquire strong and high-quality leads. High intent, measurable performance, and flexibility. These are some of the key characteristics of Google Search Ads. With an average CTR of about 3.17%, this Google ad format is definitely a hit among small to mid-sized business owners.",
    img: require("../../../src/assets/images/gridimg/PPC 1.webp")
  },
  {
    id: 2,
    heading: "Display Ads",
    para1: "Target new customers who are looking for your products and services. Use search ads for short sale cycles and pilot campaigns and acquire strong and high-quality leads. Best for increasing brand awareness and engagement; Google Display Ads can help you to reinforce brand presence across a variety of platforms.",

    img: require("../../../src/assets/images/gridimg/PPC 2.webp")
  },
  {
    id: 3,
    heading: "Social Ads",
    para1: "Looking to target users on LinkedIn, Instagram, or Facebook? Reach them through social ads, targeting their networks, hobbies, interests, etc. If you have an active social media presence, doing social ads can help you get relevant customers. Social media platforms have obtained remarkable popularity worldwide. Grab the chance to leverage the potential of these platforms towards your business growth with our expert insights and advice. As a leading PPC marketing company in India.",

    img: require("../../../src/assets/images/gridimg/PPC 3.webp")
  },
  {
    id: 4,
    heading: "Remarketing Ads",
    para1: "Retarget customers who have visited your website to take action on your brand offerings. Through lower competition and higher targeted segments, you can use PPC ad formats and extensions to develop goal-oriented results. Researches indicate more than 78% of small to midsize businesses utilize retargeting via social channels, which eventually depicts the potential of remarketing campaigns in the online business landscape.",

    img: require("../../../src/assets/images/gridimg/PPC 4.webp")
  },
  {
    id: 5,
    heading: "Google Shopping Ads",
    para1: "Appear to your potential users when they are browsing through the Google search results. Also known as Product Listing Ads, it helps you showcase your products to a global audience with the help of Google shopping ads. From building a great product feed to detailed performance tracking, SMS ZOO ZOO Technologies can help your Google ads campaign perform like never before.",

    img: require("../../../src/assets/images/gridimg/PPC 5.webp")
  },
  {
    id: 6,
    heading: " YouTube Ads",
    para1: "Is your target audience present on YouTube? Who isn’t? We can leverage PPC ads on YouTube search results, videos, and video partners on display networks. Skippable, non-skippable, in-feed, bumper, or mastheads video Ads, regardless of whatever video ad format you prefer, you can consult the experts at SMS ZOO ZOO Technologies to increase sales, leads, website traffic, or awareness.",

    img: require("../../../src/assets/images/gridimg/PPC 6.webp")
  },


]
export const gridrcs = [
  {
    id: 1,
    heading: "Get your brand noticed and remembered",
    para1: "Stand out with your recognizable brand logo, delivering messages straight into your customers’ inboxes.",
    img: require("../../../src/assets/images/gridimg/RCS sms 1.webp")
  },
  {
    id: 2,
    heading: "Enrich your messages with images, videos, and more",
    para1: "Boost your brand communication by delivering rich messages that engage and build trust. Add your logo, brand name, videos, images, and carousels to your messaging and boost conversions.",

    img: require("../../../src/assets/images/gridimg/RCS sms 2.webp")
  },
  {
    id: 3,
    heading: " Showcase your products and offers through chats",
    para1: "Attract customers by showcasing your product catalog, engaging in conversations, and converting simple queries into purchases.",

    img: require("../../../src/assets/images/gridimg/RCS sms 3.webp")
  },
  {
    id: 4,
    heading: "Personalize your offers and increase revenue",
    para1: "Understand your customers’ interests, identify their needs, and personalize your communication, building lasting relationships that drive loyalty.",

    img: require("../../../src/assets/images/gridimg/RCS sms 4.webp")
  },
  {
    id: 5,
    heading: "Improve trust and security by verifying your sender",
    para1: "Register and verify senders to ensure secure, authenticated communication and prevent fraud. It’s all about trust.",

    img: require("../../../src/assets/images/gridimg/RCS sms 5.webp")
  },
  {
    id: 6,
    heading: " Track performance and get data that matters",
    para1: "Verify message open rates and understand how customers respond and interact with detailed campaign metrics to fine-tune your activities accordingly.",

    img: require("../../../src/assets/images/gridimg/RCS sms 6.webp")
  },
  {
    id: 7,
    heading: "Customize promotional offers with a single message",
    para1: "Combine up to 10 rich cards into a single interactive unit that your customers can swipe through. Scroll, swipe, and tap – a small step in selecting the best offer for them.",

    img: require("../../../src/assets/images/gridimg/RCS sms 7.webp")
  },
  {
    id: 8,
    heading: " Boost response rates with clickable buttons",
    para1: "Allow customers to respond simply by clicking a button embedded within the conversation. Make it easier for them to reply and improve your interactions.",

    img: require("../../../src/assets/images/gridimg/RCS sms 8.webp")
  },


]

export const gridbulk = [
  {
    id: 1,
    heading: "Instant engagement",
    para1: "90% of text messages are opened within three minutes, which means SMS marketing is arguably the fastest, and most reliable way to reach your customers.",
    img: require("../../../src/assets/images/bulksms/Bulk sms 1.png")
  },
  {
    id: 2,
    heading: "Easy to measure",
    para1: "Track delivery rates, read rates, and conversions in real time. Our SMS service provides clear insights into campaign performance.",

    img: require("../../../src/assets/images/bulksms/Bulk sms 2.png")
  },
  {
    id: 3,
    heading: "No internet? No problem",
    para1: "SMS messages don’t rely on an internet connection. They are sent via cellular networks, which means your messages get delivered even if your customers don’t have internet access.",

    img: require("../../../src/assets/images/bulksms/Bulk sms 3.png")
  },
  {
    id: 4,
    heading: "Cost-effective",
    para1: "SMS marketing campaigns cost less than many traditional forms of marketing and advertising. They also typically see higher engagement rates and higher ROI than many other marketing mediums",

    img: require("../../../src/assets/images/bulksms/Bulk sms 4.png")
  },
  {
    id: 5,
    heading: "Global reach",
    para1: "With over 95% of the world’s population owning a mobile phone, your SMS service enables you to connect with customers anytime, anywhere.",

    img: require("../../../src/assets/images/bulksms/Bulk sms 5.png")
  },
]


export const whatsappBusinessApiFAQs = [
  {
    id: 1,
    question: "What are the key WhatsApp Business API documentation required to set up an account?",
    answer: [
      "A verified Meta Business Manager account.\nA phone number that is not linked to another WhatsApp account.\nBusiness verification documents – GST or other relevant document.\nAccess to a WhatsApp BSP like SMS ZOO ZOO for seamless onboarding."
    ]
  },
  {
    id: 2,
    question: "Is WhatsApp Business API Free?",
    answer:
      "You can get the WhatsApp Business API for Free with SMS ZOO ZOO but you still need to pay the platform fees & for messages charged per session in the WhatsApp Conversation-based pricing model."
  },
  {
    id: 3,
    question: "What is the WhatsApp Business API Pricing in India?",
    answer:
      "The pricing can vary depending on the region, the country code of a user and the type of conversation. For Indian Users, you'll be charged ₹0.85/ Marketing Conversation, & ₹0.15 for Utility/ Authentication Conversations."
  },
  {
    id: 4,
    question: "How to get WhatsApp Business API for FREE?",
    answer:
      "To get WhatsApp Business API, you need to connect with a WhatsApp Partner like SMS ZOO ZOO. With SMS ZOO ZOO, you can create a Free WhatsApp Business API Account."
  },
  {
    id: 5,
    question: "Can I use WhatsApp Apps & WhatsApp Business API on the same number?",
    answer:
      "No, the number which is active on WhatsApp Business API can’t be registered on WhatsApp Apps. Also, if a number is already registered on WhatsApp Apps, you must delete that WhatsApp Account to register for WhatsApp Business API."
  },
  {
    id: 6,
    question: "Can I download WhatsApp Business API?",
    answer:
      "No, the WhatsApp Business API is not an app you can download. It is a cloud-based or on-premise solution that requires integration with a business platform like SMS ZOO ZOO. You need to set it up through an official WhatsApp BSP to use it for customer messaging."
  },
  {
    id: 7,
    question: "Can I use WhatsApp API for sending messages in bulk?",
    answer:
      "Yes, businesses can send bulk messages using the WhatsApp Business API, but all messages must comply with WhatsApp’s policies. You must use pre-approved message templates for outbound notifications, while session messages (customer-initiated) allow more flexibility."
  },
  {
    id: 8,
    question: "What is the best WhatsApp Business platform for businesses?",
    answer:
      "The best WhatsApp Business platform depends on your business needs. If you’re looking for an all-in-one solution, SMS ZOO ZOO offers a powerful platform with automation, CRM integrations, campaign management, and analytics to help businesses grow using WhatsApp."
  }
];


export const clickToWhatsAppFAQ = [
  {
    id: 1,
    question: "Can I target specific audiences with Click to WhatsApp Ads?",
    answer: "Yes. Set up campaigns in Facebook Ads Manager by choosing Messaging Apps as the conversion location and Click to Message as the ad type. Our WhatsApp services support auto-replies and chatbots for incoming leads.",
  },
  {
    id: 2,
    question: "Can I track the performance of my Click to WhatsApp Ads campaigns?",
    answer: "Yes, you can. SMS ZOO ZOO solution has a dedicated Click to WhatsApp dashboard to track everything from message open rates to response times and the source URLs of the ads.",
  },
  {
    id: 3,
    question: "Does Click to WhatsApp Ads Software support both text and multimedia messages?",
    answer: "Yes, you can respond to Click to WhatsApp messages with text, images, videos, documents, or voice—whatever tells your story best. SMS ZOO ZOO builder also lets you add these elements to automated chatbot responses.",
  },
  {
    id: 4,
    question: "Can responses be automated?",
    answer: "Absolutely. Our WhatsApp services allow smart auto-replies, AI chatbots, and rule-based conversation flows for seamless automation.",
  },
  {
    id: 5,
    question: "How secure is the data from customers who interact with my Click to WhatsApp Ads?",
    answer: "All conversations that come into the Click to WhatsApp Ads software are encrypted end-to-end. As Meta’s official partner, we follow the same strict security standards that WhatsApp Business API promises and even more.",
  },
  {
    id: 6,
    question: "Can I segment leads and create targeted campaigns with Click to WhatsApp Ads Software?",
    answer: "Yes, you can break down your audience into meaningful segments based on their behaviors, custom tags, CRM properties, or their buyer stage.",
  }
];




export const WhatsAppChatbotFAQ = [
  {
    id: 1,
    question: "How do I integrate a WhatsApp chatbot with my business account?",
    answer: "Sign up, get your WhatsApp Business account verified, and access the WhatsApp Business API. Use SMS ZOO ZOO’s drag-and-drop builder to launch your WhatsApp chatbot service quickly.",
  },
  {
    id: 2,
    question: "Is coding required to set up a WhatsApp Chatbot on your platform?",
    answer: "You can build SMS ZOO ZOO WhatsApp Chatbot through three different methods: 1. With AI, 2. Using a template, or 3. From scratch. The best part is, you don’t need any coding knowledge or technical expertise. After building, you can add multiple flows to create a successful conversational chatbot.",
  },
  {
    id: 3,
    question: "Can the chatbot handle conversations at scale?",
    answer: "Yes. Our WhatsApp chatbot service manages high volumes of conversations while maintaining fast, consistent, and personalized responses.",
  },
  {
    id: 4,
    question: "How secure is the data collected through a WhatsApp Chatbot?",
    answer: "Since WhatsApp provides end-to-end encryption, the data collected through a WhatsApp Chatbot is always secure. This is another reason why using security-compliant chatbots like SMS ZOO ZOO WhatsApp Chatbot is important, as unofficial chatbots can result in data discrepancies or misuse.",
  },
  {
    id: 5,
    question: "Can I integrate the chatbot with CRM or eCommerce platforms?",
    answer: "Yes. Our WhatsApp chatbot service integrates seamlessly with CRMs and eCommerce platforms for streamlined operations.",
  },
  {
    id: 6,
    question: "Does your WhatsApp Chatbot platform support multiple languages?",
    answer: "Yes, SMS ZOO ZOO Multilingual WhatsApp Chatbot is trained to optimize for popular languages. Instead of choosing basic translation tools, opt for this chatbot for precise, consistent, and context-aware responses with natural communication.",
  },
  {
    id: 7,
    question: "What kind of analytics and reporting does the WhatsApp Chatbot provide?",
    answer: "Through the WhatsApp Chatbot, you can gather customer feedback. Customers can rate the conversation and provide additional comments, which help improve the bot’s responses and enhance engagement.",
  },
  {
    id: 8,
    question: "Is this suitable for small businesses?",
    answer: "Absolutely. The WhatsApp chatbot service is ideal for startups, SMEs, and enterprises alike.",
  },
  {
    id: 9,
    question: "What type of responses can the WhatsApp Chatbot deliver (e.g., text, images, videos)?",
    answer: "The WhatsApp Chatbot can deliver a variety of responses beyond text. It supports documents, images (JPEG, PNG), audio (AAC, MP4, AMR, MPEG, OGG), and video files (MP4, 3GPP) for rich, multimedia communication.",
  },
  {
    id: 10,
    question: "Does the WhatsApp Chatbot platform support multiple agents or teams?",
    answer: "SMS ZOO ZOO Shared Inbox feature enables full team access to user-business conversations. Conversations can be assigned to a bot or agents based on a round-robin basis or their availability.",
  },
];





export const WhatsAppBlueTickFAQ = [
  {
    id: 1,
    question: "Is WhatsApp Blue Tick and Green Tick the same?",
    answer: "Yes, WhatsApp recently changed the WhatsApp Green Tick to WhatsApp Blue Tick to maintain a consistent verified tick branding across all its platforms, including Facebook, Instagram, and now WhatsApp.",
  },
  {
    id: 2,
    question: "How to get a Blue verified tick on WhatsApp for FREE?",
    answer: "You can apply for the blue verified tick on WhatsApp using SMS ZOO ZOO, an official WhatsApp API-based platform! Once you get verified, you can keep the blue tick live on your profile for a lifetime with SMS ZOO ZOO.",
  },
  {
    id: 3,
    question: "How long does WhatsApp Blue Tick approval take?",
    answer: "WhatsApp Blue Tick approval takes anywhere between 5-10 business days! Approval or rejection of your WhatsApp Business verified badge depends completely on WhatsApp, and you will receive a response in your registered mail.",
  },
  {
    id: 4,
    question: "What happens if my WhatsApp verification request is denied?",
    answer: "In case your WhatsApp verification request is denied, SMS ZOO ZOO allows you to reapply for the WhatsApp Blue Tick verification after 1 month of getting rejected! There are no limits to the number of times you can reapply for the Blue Tick with SMS ZOO ZOO.",
  },
  {
    id: 5,
    question: "Does SMS ZOO ZOO guarantee WhatsApp Blue Tick verification?",
    answer: "No! SMS ZOO ZOO cannot guarantee that you will get the verified WhatsApp Blue Tick on your business profile because the decision to approve your Blue Tick request is completely in the hands of WhatsApp.",
  },
];

export const blueTickRequirements = [
  {
    title: "WhatsApp API Setup",
    description: "Your business must be live & active on WhatsApp Business API!"
  },
  {
    title: "Complete Facebook Business Verification",
    description: "You must complete the Meta business verification process on your Meta Business Manager account."
  },
  {
    title: "5 Organic PR/ News Article",
    description: "You must have at least 5 organic PR/ news articles published for your brand online. Note: Paid PR doesn't count!"
  },
  {
    title: "Tier 2 or Above Messaging Level",
    description: "Your account must be in Tier 2 or above messaging level. While Tier 1 may also apply, you must have exchanged 10-15 messages first."
  },
  {
    title: "2FA Verification",
    description: "Turn on 2-step verification to apply for official WhatsApp Blue tick"
  },
  {
    title: "Notable and Reputable Business",
    description: "Your business must be a notable and reputable business."
  }
];

export const whatsappServiceDetails = [
  {
    title: "<strong>Instant WhatsApp Business API Activation</strong>",
    points: [
      "<strong>Quick onboarding</strong> with the official WhatsApp Business API using secure and scalable WhatsApp services, including verified blue tick setup (if eligible).",
    ],
    img: require('../../assets/images/whatwedonew/WhatsApp 1.webp')
  },
  {
    title: "<strong>Sender ID & Business Profile Setup</strong>",
    points: [
      "Help you configure your <strong>business display name</strong>, logo, and contact info.",
      "Assistance with <strong>business verification via Facebook Business Manager.</strong>",
    ],
    img: require('../../assets/images/whatwedonew/WhatsApp 2.webp')
  },
  {
    title: "<strong>Template Message Registration</strong>",
    points: [
      "Draft, format, and submit your <strong> message templates </strong> for WhatsApp approval.",
      "Templates for <strong>OTPs, shipping updates, appointment reminders, promotional offers,</strong> and more.",
    ],
    img: require('../../assets/images/whatwedonew/WhatsApp 3.webp')
  },
  {
    title: "<strong> API & Platform Integration</strong>",
    points: [
      "Seamless <strong>REST API </strong>integration with your <strong>website, mobile app, CRM, or chatbot.</strong>",
      "Our WhatsApp services support platforms like <strong>Shopify, Zoho, Freshdesk, </strong>and more."
    ],
    img: require('../../assets/images/whatwedonew/WhatsApp 4.webp')
  },
  {
    title: "<strong> WhatsApp Chatbot Development (Optional)</strong>",
    points: [
      "Create AI-powered chatbots for customer service, lead generation, FAQs, and bookings.",
      "Multilingual and flow-based conversational design.",
    ],
    img: require('../../assets/images/whatwedonew/WhatsApp 5.webp')
  },
  {
    title: "<strong> Campaign Management & Analytics</strong>",
    points: [
      "Real-time delivery, read status, and click-through tracking.",
      "Broadcast scheduler and performance reports.",
    ],
    img: require('../../assets/images/whatwedonew/WhatsApp 6.webp')
  },
];

export const smsServiceDetails = [
  {
    title: "<strong> Sender ID (Header) Registration</strong>",
    points: [
      "We assist you in registering your 6-character Sender ID through authorized DLT platforms, ensuring your SMS service is fully compliant and brand-approved."
    ],
    img: require('../../assets/images/whatwedonew/SMS 1.webp')
  },
  {
    title: "<strong> Template Registration</strong>",
    points: [
      "Help with submitting and getting SMS templates approved (per TRAI DLT regulations)."
    ],
    img: require('../../assets/images/whatwedonew/SMS 2.webp')
  },
  {
    title: "<strong> DLT Registration Assistance</strong>",
    points: [
      "Complete onboarding support on leading DLT platforms such as Jio, Airtel, and Vodafone-Idea to activate your bulk SMS service quickly."
    ], img: require('../../assets/images/whatwedonew/SMS 3.webp')
  },
  {
    title: "<strong> API & Platform Integration</strong>",
    points: [
      "Ready-to-use APIs for websites, apps, CRM, or ERP tools.",
      "Sample code and tech support for seamless integration."
    ],
    img: require('../../assets/images/whatwedonew/SMS 4.webp')
  },
  {
    title: "<strong> Campaign Management & Analytics</strong>",
    points: [
      "Real-time delivery reports",
      "Dashboard access for scheduling and automation"
    ], img: require('../../assets/images/whatwedonew/SMS 5.webp')
  }
];
export const rcsServiceDetails = [
  {
    title: "<strong> RCS Brand Registration</strong>",
    points: [
      "We help you register your brand under Google’s RCS Business Messaging (RBM) program.",
      "This includes verified sender setup with your official business name, logo, and contact details to build trust and brand recognition."
    ],
    img: require('../../assets/images/whatwedonew/RCS SMS 1.webp')
  },
  {
    title: "<strong> Sender ID Approval</strong>",
    points: [
      "Once your business is registered with your chosen messaging partner, they will submit your <strong> Sender ID </strong>(brand name) for <strong>Google verification.</strong>"
    ],
    img: require('../../assets/images/whatwedonew/RCS SMS 2.webp')
  },
  {
    title: "<strong> Template Registration</strong>",
    points: [
      "Once the Sender ID is approved, you can start submitting <strong>message templates</strong> for RCS, such as:",
      "<strong>Interactive messages:</strong> Including <strong>buttons, images,</strong> and <strong>carousel cards.</strong>",
      "<strong>Rich media:</strong> Offering features like <strong>video <strong>or <strong>product catalogs.</strong>"
    ],
    img: require('../../assets/images/whatwedonew/RCS SMS 3.webp')
  },
  {
    title: "<strong> API Integration & Platform Setup</strong>",
    points: [
      "Provide RCS APIs or integrate with your CRM, app, or backend system.",
      "Dashboard access for managing contacts, scheduling campaigns, and viewing analytics."
    ],
    img: require('../../assets/images/whatwedonew/RCS SMS 4.webp')
  },
  {
    title: "<strong> Campaign Management</strong>",
    points: [
      "Run promotional, transactional, and service-based RCS campaigns.",
      "Monitor message delivery, read receipts, and user interactions in real time."
    ],
    img: require('../../assets/images/whatwedonew/RCS SMS 5.webp')
  }
];
export const socialMediaServiceDetails = [
  {
    title: "<strong> Social Media Strategy Development</strong>",
    points: [
      "Build a tailored social media roadmap aligned with your brand goals.",
      "Identify the right platforms (Facebook, Instagram, LinkedIn, etc.).",
      "Content calendars and growth strategy plans."
    ],
    img: require('../../assets/images/whatwedonew/social media 1.webp')
  },
  {
    title: "<strong>Social Media Advertising (Paid Ads)</strong>",
    points: [
      "Our social media marketing services include planning and executing high-performing Facebook and Instagram ad campaigns.",
      "We handle audience segmentation, A/B testing, creative optimization, and budget management to drive leads, website traffic, and conversions."
    ],
    img: require('../../assets/images/whatwedonew/social media 2.webp')
  },
  {
    title: "<strong> Analytics & Performance Reporting</strong>",
    points: [
      "Track metrics like reach, engagement, followers, clicks, and conversions.",
      "ROI tracking and ad spend efficiency."
    ],
    img: require('../../assets/images/whatwedonew/social media 3.webp')
  },
  {
    title: "<strong> Profile Setup & Optimization</strong>",
    points: [
      "Create or audit your social profiles for branding.",
      "Optimize bio, images, highlights, and CTA buttons."
    ],
    img: require('../../assets/images/whatwedonew/social media 4.webp')
  }
];


export const linkedInServiceDetails = [
  {
    title: "<strong>LinkedIn Profile & Company Page Optimization</strong>",
    points: [
      "Optimize individual and business profiles for maximum professional impact.",
      "Ensure credibility, trust, and alignment with your target audience."
    ],
    img: require('../../assets/images/whatwedonew/LinkedIn 1.webp')
  },
  {
    title: "<strong> LinkedIn Lead Generation (B2B Focused)</strong>",
    points: [
      "Identify and connect with decision-makers, prospects, or investors.",
      "Leverage Sales Navigator and automation tools for smart targeting."
    ],
    img: require('../../assets/images/whatwedonew/LinkedIn 2.webp')
  },
  {
    title: "<strong> LinkedIn Ads Management</strong>",
    points: [
      "Run Sponsored Content, Lead Gen Forms, InMail campaigns, and Retargeting Ads.",
      "Precise targeting by job title, industry, seniority, and geography.",
      "A/B testing, performance tracking, and budget optimization."
    ],
    img: require('../../assets/images/whatwedonew/LinkedIn 3.webp')
  },
  {
    title: "<strong> Analytics, Reporting & Strategy Refinement</strong>",
    points: [
      "Track impressions, clicks, engagement, profile views, and lead quality.",
      "Adjust strategy based on data and trends."
    ],
    img: require('../../assets/images/whatwedonew/LinkedIn 4.webp')
  }
];

export const seoServiceDetails = [
  {
    title: "<strong> SEO Audit & Strategy</strong>",
    points: [
      "Full website audit covering technical, on-page, and off-page SEO.",
      "Competitor analysis and keyword gap analysis."
    ],
    img: require('../../assets/images/whatwedonew/SEO 1.webp')
  },
  {
    title: "<strong> On-Page SEO</strong>",
    points: [
      "Keyword research and optimization.",
      "Meta tags, headers, content structure, internal linking, and URL optimization."
    ],
    img: require('../../assets/images/whatwedonew/SEO 2.webp')
  },
  {
    title: "<strong> Off-Page SEO & Link Building</strong>",
    points: [
      "Ethical, high-authority backlink acquisition strategies.",
      "Outreach to relevant blogs, media, and directories."
    ],
    img: require('../../assets/images/whatwedonew/SEO 3.webp')
  },
  {
    title: "<strong> Local SEO Optimization</strong>",
    points: [
      "Our SEO services include Google Business Profile setup, local keyword optimization, and review management to help businesses gain visibility in location-specific searches."    ],
    img: require('../../assets/images/whatwedonew/SEO 4.webp')
  }
];

export const ppcServiceDetails = [
  {
    title: "<strong> PPC Strategy & Planning</strong>",
    points: [
      "Choose the right platforms (Google Ads, Facebook Ads, LinkedIn Ads, etc.).",
      "Develop a complete PPC roadmap tailored to your objectives."
    ],
    img: require('../../assets/images/whatwedonew/PPC 1.webp')
  },
  {
    title: "<strong> Keyword Research & Targeting</strong>",
    points: [
      "In-depth keyword research for search intent and conversion potential.",
      "Competitor keyword gap analysis."
    ],
    img: require('../../assets/images/whatwedonew/PPC 2.webp')
  },
  {
    title: "<strong> Social Media Ads</strong>",
    points: [
      "Reach your audience on platforms like Facebook, Instagram, and LinkedIn by targeting interests, job roles, behaviors, and demographics. As a leading PPC advertising agency in India, we help businesses leverage social ads to attract relevant customers and accelerate growth."    ], img: require('../../assets/images/whatwedonew/PPC 3.webp')
  },
  {
    title: "<strong> Budget & Bid Management</strong>",
    points: [
      "Smart bidding strategies (CPC, CPA, ROAS-focused).",
      "Daily monitoring and adjustments to maximize ad spend efficiency."
    ],
    img: require('../../assets/images/whatwedonew/PPC 4.webp')
  },
  {
    title: "<strong> Performance Tracking & Reporting</strong>",
    points: [
      "Conversion tracking setup with Google Tag Manager.",
      "Monthly reports covering impressions, CTR, CPC, conversions, and ROI."
    ],
    img: require('../../assets/images/whatwedonew/PPC 5.webp')
  }
];

export const googleAdsServiceDetails = [
  {
    title: "<strong> Google Ads Strategy & Audit</strong>",
    points: [
      "In-depth audit of existing campaigns (if applicable).",
      "Competitor and keyword research."
    ],
    img: require('../../assets/images/whatwedonew/Google ads 1.webp')
  },
  {
    title: "<strong> Keyword Research & Planning</strong>",
    points: [
      "Discover high-intent, high-converting keywords.",
      "Setup of negative keywords to reduce wasteful spend."
    ],
    img: require('../../assets/images/whatwedonew/Google ads 2.webp')
  },
  {
    title: "<strong> Campaign Creation & Setup</strong>",
    points: [
      "Search Ads / Display Ads",
      "YouTube Video Ads / Shopping Ads (for eCommerce)"
    ],
    img: require('../../assets/images/whatwedonew/Google ads 3.webp')
  },
  {
    title: "<strong> Budget Management & Bid Optimization</strong>",
    points: [
      "Daily monitoring of CPC, CPA, and ROAS.",
      "Implement automated bidding strategies (Maximize Conversions, Target ROAS, etc.)."
    ],
    img: require('../../assets/images/whatwedonew/Google ads 4.webp')
  }
];


export const whatsappMarketingBenefits = [
  {
    title: "Improve Relations and Connectivity",
    points: [
      "Add a personal touch with personalized messages",
      "Real-time live chat for instant conversations"
    ]
  },
  {
    title: "Build Trust and Authenticity",
    points: [
      "Get verified with the WhatsApp Green Tick",
      "Showcase your brand's authenticity and uniqueness"
    ]
  },
  {
    title: "Boost Customer Satisfaction",
    points: [
      "Respond instantly to customer queries",
      "Multi-human Live Chat for quick support"
    ]
  },
  {
    title: "Reduce Costs and Efforts",
    points: [
      "150X ROI potential at a fraction of the cost",
      "Automate sales and support with chatbots"
    ]
  }
];

